<div
  class="nav-bar"
  [class.dark-theme]="isDarkTheme"
  [class.dock-on-right]="dockSide === 'right'"
  [class.is-home]="isHomeRoute"
  [class.is-dragging]="isDraggingDock"
  style="height: var(--dvh, 100vh); min-height: var(--dvh, 100vh); overflow: hidden;">
  <canvas class="bgfx-orchestra" aria-hidden="true"></canvas>
  <div class="bgfx-labels" aria-hidden="true">
    <span class="bgfx-label bgfx-a">transient</span>
    <span class="bgfx-label bgfx-b">scheduler</span>
    <span class="bgfx-label bgfx-c">validator</span>
    <span class="bgfx-label bgfx-d">retrieve</span>
    <span class="bgfx-label bgfx-e">persist</span>
    <span class="bgfx-label bgfx-f">oopschestrator</span>
    <span class="bgfx-label bgfx-g">working...</span>
    <span class="bgfx-label bgfx-h">translate</span>
    <span class="bgfx-label bgfx-i">integrate</span>
  </div>

  <div class="drop-preview drop-left" [class.active]="isDraggingDock && previewSide === 'left'"></div>
  <div class="drop-preview drop-right" [class.active]="isDraggingDock && previewSide === 'right'"></div>

  <button
    mat-icon-button
    class="mobile-menu-toggle"
    *ngIf="isMobileLayout && sideNavVisible"
    (click)="toggleSidebar()"
    aria-label="Toggle navigation menu">
    <mat-icon>menu</mat-icon>
  </button>

  <div
    class="dock-brand-outside"
    *ngIf="sideNavVisible"
    [attr.aria-label]="dockBrandName">
    {{ dockBrandName }}
  </div>

  <mat-sidenav-container class="app-shell" [class.sidenav-hidden]="!sideNavVisible" [autosize]="true">
    <mat-sidenav
      *ngIf="sideNavVisible"
      [mode]="isMobileLayout ? 'over' : 'side'"
      [opened]="isMobileLayout ? isMobileDrawerOpen : true"
      [position]="dockSide === 'right' ? 'end' : 'start'"
      class="sidenav dock-sidenav"
      [style.width]="sidenavWidth"
      [style.overflow]="'visible'">

      <nav
        class="futuristic-dock"
        aria-label="Dashboard navigation"
        [class.shrunk]="shrinkDock"
        [class.dock-right]="dockSide === 'right'"
        [class.dragging]="isDraggingDock"
        (mouseleave)="clearHoverNavigation(); hideDockTooltip()"
        (click)="$event.stopPropagation()">
        <!-- <div class="dock-brand-top" aria-label="SIM">SIM</div> -->
        <!-- <button
          type="button"
          class="dock-handle"
          (mousedown)="startDockDrag($event)"
          aria-label="Drag navigation dock"
          title="Drag to move dock">
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span>
        </button> -->

        <!-- <button
          type="button"
          class="dock-logo"
          matTooltip="SIM FOUNDRY"
          [matTooltipPosition]="dockSide === 'right' ? 'left' : 'right'"
          aria-label="SIM FOUNDRY">
          <span>3.0</span>
        </button> -->

        <button
          #userAvatar
          type="button"
          class="user-avatar"
          [class.active]="accountOpen"
          (mouseenter)="openAccountCardHover()"
          (mouseleave)="closeAccountCardHover()"
          (click)="openAccountCardHover()"
          aria-label="Account">
          <span>{{ getUserInitials() }}</span>
        </button>

        <div
          class="dock-links"
          [class.overflow-open]="overflowOpen"
          (mouseenter)="openOverflow()"
          (mouseleave)="scheduleCloseOverflow()">

          <!-- Prototype rail fits eight module icons before overflow is needed. -->
          <ng-container *ngFor="let item of primaryMenuItems">
            <ng-container
              [ngTemplateOutlet]="dockLinkTpl"
              [ngTemplateOutletContext]="{ item: item }"></ng-container>
          </ng-container>

          <!-- "More" chip — shown only when there are hidden items and the
               overflow is currently collapsed. -->
          <button
            *ngIf="hasOverflowItems"
            type="button"
            class="dock-more"
            [class.is-hidden]="overflowOpen"
            [attr.aria-label]="'Show ' + overflowCount + ' more'"
            (mouseenter)="openOverflow(); showDockTooltip($event, overflowCount + ' more')"
            (mouseleave)="hideDockTooltip()"
            (focus)="openOverflow()"
            (click)="openOverflow()">
            <svg class="dock-more-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 8 12 13.5 18 8"/>
              <polyline points="6 14 12 19.5 18 14"/>
            </svg>
          </button>

          <!-- Revealed overflow items — animate open on hover, staggered. -->
          <div class="dock-overflow" *ngIf="hasOverflowItems" [class.open]="overflowOpen">
            <div class="dock-overflow-inner">
              <div
                class="dock-overflow-item"
                *ngFor="let item of overflowMenuItems; let i = index"
                [style.transitionDelay]="overflowOpen ? (i * 45 + 60) + 'ms' : '0ms'">
                <ng-container
                  [ngTemplateOutlet]="dockLinkTpl"
                  [ngTemplateOutletContext]="{ item: item }"></ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- Global tooltip rendered at dock level — always outside the scroll container -->
        <div
          class="dock-global-tooltip"
          [class.visible]="dockTooltipVisible"
          [class.tip-right]="dockSide === 'right'"
          [style.top]="dockTooltipStyle.top"
          [style.left]="dockTooltipStyle.left"
          aria-hidden="true">{{ dockTooltipText }}</div>

        <!-- Reusable dock link (leaf button, parent button, or submenu) -->
        <ng-template #dockLinkTpl let-item="item">
          <button
            type="button"
            *ngIf="!hasChildren(item)"
            class="dock-link"
            [class.active]="isActive(item)"
            [class.disabled]="item.moduleDisabled"
            [disabled]="item.moduleDisabled"
            [attr.aria-disabled]="item.moduleDisabled || null"
            [attr.aria-label]="item.name"
            (mouseenter)="onRailItemHover(item); showDockTooltip($event, item.name)"
            (mouseleave)="clearHoverNavigation(); hideDockTooltip()"
            (focus)="onRailItemHover(item); showDockTooltip($event, item.name)"
            (blur)="clearHoverNavigation(); hideDockTooltip()"
            (click)="navigateToMenuItem(item)">
            <ng-container [ngTemplateOutlet]="navIconTpl" [ngTemplateOutletContext]="{ $implicit: item.icon }"></ng-container>
          </button>

          <button
            type="button"
            *ngIf="hasChildren(item)"
            class="dock-link"
            [class.active]="isMenuActive(item)"
            [class.menu-open]="isMenuExpanded(item.name)"
            [class.disabled]="item.moduleDisabled"
            [disabled]="item.moduleDisabled"
            [attr.aria-disabled]="item.moduleDisabled || null"
            [attr.aria-label]="item.name"
            (mouseenter)="openMenuOnHover(item); showDockTooltip($event, item.name)"
            (mouseleave)="clearHoverNavigation(); hideDockTooltip()"
            (focus)="openMenuOnHover(item); showDockTooltip($event, item.name)"
            (blur)="clearHoverNavigation(); hideDockTooltip()"
            (click)="toggleSubmenu(item.name, $event)">
            <ng-container [ngTemplateOutlet]="navIconTpl" [ngTemplateOutletContext]="{ $implicit: item.icon || 'folder' }"></ng-container>
          </button>

          <div
            class="dock-submenu"
            *ngIf="hasChildren(item) && isMenuExpanded(item.name)">
            <button
              type="button"
              *ngFor="let child of getMenuChildren(item)"
              class="dock-subitem"
              [class.active]="isActive(child)"
              [class.disabled]="child.moduleDisabled"
              [disabled]="child.moduleDisabled"
              [attr.aria-disabled]="child.moduleDisabled || null"
              (mouseenter)="scheduleHoverNavigation(child)"
              (mouseleave)="clearHoverNavigation()"
              (focus)="scheduleHoverNavigation(child)"
              (blur)="clearHoverNavigation()"
              (click)="navigateToMenuItem(child)">
              <mat-icon>{{ child.icon || 'chevron_right' }}</mat-icon>
              <span>{{ child.name }}</span>
            </button>
          </div>
        </ng-template>

        <div class="dock-bottom">
          <button
            type="button"
            class="dock-link btn-notif"
            [class.active]="notificationsOpen"
            (mouseenter)="openNotificationsHover()"
            (mouseleave)="closeNotificationsHover()"
            (click)="openNotificationsHover()"
            aria-label="Notifications">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
            <span class="notification-badge" *ngIf="notificationCount">
              {{ notificationCount > 99 ? '99+' : notificationCount }}
            </span>
            <!-- <span class="dock-tooltip">Notifications</span> -->
          </button>

          <button
            type="button"
            class="dock-link settings-dock-link"
            [class.active]="settingsOpen"
            (mouseenter)="openSettingsHover()"
            (mouseleave)="closeSettingsHover()"
            (click)="openSettingsHover()"
            aria-label="Settings">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
            <!-- <span class="dock-tooltip">Settings</span> -->
          </button>

          <div class="sim-brand-mark" aria-hidden="true">
            <span class="sim-text">SIM</span>
            <div class="sim-descriptor">
              <span class="sim-sub">Foundry</span>
              <div class="logo-box">3.0</div>
            </div>
          </div>
          
        </div>
      </nav>
    </mat-sidenav>

    <mat-sidenav-content class="app-content" [class.route-transitioning]="isRouteTransitioning" [class.sidenav-hidden]="!sideNavVisible" [class.viewport-content]="viewportContent">
      <div
        class="app-page"
        [class.has-welcome-header]="shouldShowWelcomeHeader"
        [style.padding]="contentPadding"
        [style.height]="contentHeight"
        [style.min-height]="contentMinHeight"
        (mouseenter)="shrinkDock = true">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <div
    class="settings-popover appearance-popover"
    [class.open]="settingsOpen"
    [class.dock-right-pop]="dockSide === 'right'"
    (mouseenter)="openSettingsHover()"
    (mouseleave)="closeSettingsHover()"
    (click)="$event.stopPropagation()">
    <div class="appearance-title">Appearance</div>

    <div class="appearance-label">Mode</div>
    <div class="theme-mode-row" role="group" aria-label="Theme mode">
      <button
        type="button"
        class="theme-choice"
        *ngFor="let mode of themeModeOptions"
        [class.active]="isThemeModeSelected(mode.id)"
        [class.disabled]="mode.disabled"
        [disabled]="mode.disabled"
        [attr.aria-disabled]="mode.disabled || null"
        [attr.title]="mode.disabled ? mode.label + ' mode is disabled' : null"
        (click)="selectThemeMode(mode.id)">
        <mat-icon>{{ mode.icon }}</mat-icon>
        <span>{{ mode.label }}</span>
      </button>
    </div>

    <div class="appearance-label accent-label">Accent</div>
    <div class="accent-choice-row" role="group" aria-label="Theme accent">
      <button
        type="button"
        class="accent-choice"
        *ngFor="let accent of accentOptions"
        [class.active]="selectedAccentId === accent.id"
        [class.disabled]="accent.disabled"
        [disabled]="accent.disabled"
        [attr.aria-disabled]="accent.disabled || null"
        [attr.title]="accent.disabled ? accent.label + ' accent is disabled' : null"
        (click)="selectAccent(accent)">
        <span class="accent-dot" [style.background]="accent.color"></span>
        <span>{{ accent.label }}</span>
      </button>
    </div>

    <div class="appearance-footer" *ngIf="hasPendingThemePreview">
      <button type="button" class="save-theme-chip" (click)="saveThemePreview()">
        <mat-icon>save</mat-icon>
        <span>Save theme</span>
      </button>
    </div>
  </div>
  <div
    class="notif-popover"
    [class.open]="notificationsOpen"
    [class.dock-right-pop]="dockSide === 'right'"
    (mouseenter)="openNotificationsHover()"
    (mouseleave)="closeNotificationsHover()"
    (click)="$event.stopPropagation()">
    <div class="notif-head">
      <div class="popover-title">Notifications</div>
      <button type="button" class="text-action" (click)="clearNotifications()">Clear all</button>
    </div>
    <lib-business-alerts
      [config]="notificationListConfig"
      [compactItems]="notifications"
      [compactLoading]="notificationsLoading"
      [compactError]="notificationsError"
      (downloadItem)="downloadNotificationFile($event)">
    </lib-business-alerts>
  </div>


  <div
    class="account-popover"
    [class.open]="accountOpen"
    [class.dock-right-pop]="dockSide === 'right'"
    [style.top]="popoverPos.top"
    [style.left]="popoverPos.left"
    (mouseenter)="openAccountCardHover()"
    (mouseleave)="closeAccountCardHover()"
    (click)="$event.stopPropagation()">
    <div class="ac-identity">
      <div class="ac-avatar">{{ getUserInitials() }}</div>
      <div>
        <div class="ac-name">{{ username || 'Application User' }}</div>
        <!-- <div class="ac-email">DVM Platform</div> -->
      </div>
    </div>
    <div class="ac-role-chip">
      <mat-icon>verified_user</mat-icon>
      <span>Signed in</span>
    </div>
    <div class="ac-divider"></div>
    <button type="button" class="ac-logout-btn" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </div>

  <!-- Custom nav icon set (keyed by the menu item's material-icon name) -->
  <ng-template #navIconTpl let-icon>
    <ng-container [ngSwitch]="icon">
      <svg *ngSwitchCase="'ttm'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M3 7h4"/><path d="M3 12h4"/><path d="M3 17h4"/><rect x="7" y="4.5" width="10" height="15" rx="2"/>
        <path d="M17 12h4"/><path d="M21 10l2 2-2 2"/>
      </svg>
      <!-- Application launcher -->
      <svg *ngSwitchCase="'house'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="5" cy="5" r="1.7"/><circle cx="12" cy="5" r="1.7"/><circle cx="19" cy="5" r="1.7"/>
        <circle cx="5" cy="12" r="1.7"/><circle cx="12" cy="12" r="1.7"/><circle cx="19" cy="12" r="1.7"/>
        <circle cx="5" cy="19" r="1.7"/><circle cx="12" cy="19" r="1.7"/><circle cx="19" cy="19" r="1.7"/>
      </svg>
      <!-- SPRICED modules -->
      <svg *ngSwitchCase="'extension'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/>
        <rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>
      </svg>
      <!-- Home -->
      <svg *ngSwitchCase="'home'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1.5"/>
        <rect x="14" y="3" width="7" height="7" rx="1.5"/>
        <rect x="3" y="14" width="7" height="7" rx="1.5"/>
        <rect x="14" y="14" width="7" height="7" rx="1.5"/>
      </svg>
      <!-- Product Catalogs -->
      <svg *ngSwitchCase="'dataset'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M2 7.5L12 3l10 4.5-10 4.5z"/>
        <path d="M2 12l10 4.5 10-4.5"/>
        <path d="M2 16.5l10 4.5 10-4.5"/>
      </svg>
      <!-- Customer Catalogs -->
      <svg *ngSwitchCase="'collections_bookmark'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 2H5a2 2 0 0 0-2 2v4"/>
        <path d="M15 2h4a2 2 0 0 1 2 2v4"/>
        <path d="M3 14v4a2 2 0 0 0 2 2h4"/>
        <path d="M15 22h4a2 2 0 0 0 2-2v-4"/>
        <line x1="9" y1="15" x2="15" y2="9"/>
        <circle cx="9.5" cy="9.5" r="1.5"/>
        <circle cx="14.5" cy="14.5" r="1.5"/>
      </svg>
      <!-- Price List Catalogs -->
      <svg *ngSwitchCase="'request_quote'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 3h9l3 3v13a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
        <path d="M14 3v3h3"/>
        <path d="M12 9v6.5"/>
        <path d="M13.75 10h-2.5a1.25 1.25 0 0 0 0 2.5h1.5a1.25 1.25 0 0 1 0 2.5h-2.5"/>
      </svg>
      <!-- Dashboards -->
      <svg *ngSwitchCase="'bar_chart'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="12" width="4" height="9" rx="1"/>
        <rect x="10" y="7" width="4" height="14" rx="1"/>
        <rect x="17" y="3" width="4" height="18" rx="1"/>
      </svg>
      <!-- Approval Workflows / DOA Configuration -->
      <svg *ngSwitchCase="'account_tree'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="4" r="2"/>
        <path d="M12 6v3"/>
        <path d="M7.5 12.5L12 9l4.5 3.5"/>
        <path d="M7.5 12.5v5"/>
        <path d="M16.5 12.5v5"/>
        <circle cx="7.5" cy="18" r="1.5"/>
        <circle cx="16.5" cy="18" r="1.5"/>
        <path d="M12 9v-.5"/>
      </svg>
      <!-- DEAM Service -->
      <svg *ngSwitchCase="'storage'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2"/>
        <path d="M2 9.5h20"/>
        <path d="M8 9.5v9.5"/>
        <path d="M2 14h20"/>
        <circle cx="5" cy="7.25" r="1" fill="currentColor" stroke="none"/>
      </svg>
      <!-- I/O Workflows -->
      <svg *ngSwitchCase="'settings_input_component'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 7h4"/>
        <path d="M3 12h4"/>
        <path d="M3 17h4"/>
        <rect x="7" y="4.5" width="10" height="15" rx="2"/>
        <path d="M17 12h4"/>
        <path d="M21 10l2 2-2 2"/>
      </svg>
      <!-- User Access -->
      <svg *ngSwitchCase="'key'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="8" cy="11" r="4"/>
        <path d="M12 11h8"/>
        <path d="M18 11v3"/>
        <path d="M15 11v2"/>
      </svg>
      <svg *ngSwitchCase="'local_offer'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M4 4h7l9 9-7 7-9-9z"/><circle cx="8.5" cy="8.5" r="1.4"/>
      </svg>
      <svg *ngSwitchCase="'insights'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/><path d="M12 6v2M12 16v2M8.5 9.5a3.5 1.5 0 0 1 7 0c0 1.5-1.5 2-3.5 2.5S8.5 13 8.5 14.5a3.5 1.5 0 0 0 7 0"/>
      </svg>
      <!-- Workflow Sequences: icon only; the dock supplies hover/active styling. -->
      <svg *ngSwitchCase="'share'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="18" cy="5" r="2.5"/>
        <circle cx="6" cy="12" r="2.5"/>
        <circle cx="18" cy="19" r="2.5"/>
        <path d="M8.2 10.8l7.6-4.4M8.2 13.2l7.6 4.4"/>
      </svg>
      <!-- Workflow Chain / Workflow Sequences -->
      <svg *ngSwitchCase="'link'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="8" width="7" height="6" rx="1.5"/>
        <rect x="15" y="3" width="7" height="6" rx="1.5"/>
        <rect x="15" y="15" width="7" height="6" rx="1.5"/>
        <path d="M9 11h3l3-5M9 11h3l3 5"/>
      </svg>
      <svg *ngSwitchCase="'schema'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="8" width="7" height="6" rx="1.5"/>
        <rect x="15" y="3" width="7" height="6" rx="1.5"/>
        <rect x="15" y="15" width="7" height="6" rx="1.5"/>
        <path d="M9 11h3l3-5M9 11h3l3 5"/>
      </svg>
      <svg *ngSwitchCase="'audit'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M9 11l3 3 8-8"/><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9"/>
      </svg>
      <!-- Fallback: material font icon -->
      <mat-icon *ngSwitchDefault>{{ icon || 'dashboard' }}</mat-icon>
    </ng-container>
  </ng-template>
</div>

